import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const toPay = async (params: object) => {
  return await POST({
    url: Api.toPay,
    data: params,
    showError: false
  })
}
export const switchInfo = async (params: object) => {
  return await GET({
    url: Api.switch,
    params,
    showError: false
  })
}
